// Styles for LegalMultiLink go here.
import styled from 'styled-components';

export const StyledLegalMultiLink = styled.div`
  display: none;
  justify-content: center;

  @media screen and (min-width: 992px) {
    display: flex;
    position: sticky;
    top: 0;
    z-index: 49; /* DPO-84336: must stay below header sub-nav (z-index ~50); was 1000 which caused overlap */
    background: #fff;
  }

  .multiLink-nav {
    display: flex;
    gap: 20px;
    align-items: center;
    width: 70%;
    padding: 20px 0;
  }

  .multiLink-link {
    text-decoration: none;
    color: #000;
    font-weight: unset;
  }

  .multiLink-link.active,
  .multiLink-link:hover {
    font-weight: bold;
    border-bottom: 2px solid #968a83;
  }
`;
